export const initial = {
  total: 0,
  top: [],
  myRange: []
};

export default (state = initial, action = {}) => {
  switch (action.type) {
    case 'GLOBAL_RANKING_TOP_SET':
      return { ...state, top: action.payload };
    case 'GLOBAL_RANKING_MYRANGE_SET':
      return { ...state, myRange: action.payload };
    case 'GLOBAL_RANKING_TOTAL_SET':
      return { ...state, total: action.payload };
    default:
      return state;
  }
};
